"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _styles = require("@material-ui/core/styles");
var _core = require("@material-ui/core");
var _ExpandLess = _interopRequireDefault(require("@material-ui/icons/ExpandLess"));
var _Check = _interopRequireDefault(require("@material-ui/icons/Check"));
var _clsx4 = _interopRequireDefault(require("clsx"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
var __jsx = _react.default.createElement;
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    wrapper: (0, _defineProperty2.default)({
      width: '100%'
    }, theme.breakpoints.up('md'), {
      marginTop: theme.spacing(4.5)
    }),
    accordian: (0, _defineProperty2.default)({
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      borderBottom: "2px solid ".concat(theme.palette.grey['400'])
    }, theme.breakpoints.up('md'), {
      display: 'none'
    }),
    expandIcon: {
      fontSize: theme.typography.pxToRem(20),
      color: theme.palette.primary.main,
      transition: 'transform 0.25s'
    },
    expandIconIsOpen: {
      transform: 'rotate(180deg)'
    },
    formGroup: {
      marginTop: theme.spacing(1)
    },
    label: (0, _defineProperty2.default)({
      marginBottom: theme.spacing(2.5),
      lineHeight: 1.43,
      fontWeight: theme.typography.fontWeightMedium,
      fontSize: theme.typography.pxToRem(16)
    }, theme.breakpoints.up('md'), {
      marginBottom: theme.spacing(4),
      fontSize: theme.typography.pxToRem(14)
    }),
    labelDesktop: (0, _defineProperty2.default)({
      display: 'none'
    }, theme.breakpoints.up('md'), {
      display: 'block',
      marginBottom: theme.spacing(3.5)
    }),
    link: (0, _defineProperty2.default)({
      marginTop: theme.spacing(4),
      fontSize: theme.typography.pxToRem(14),
      lineHeight: 1.43,
      fontWeight: theme.typography.fontWeightBold,
      textDecoration: 'none',
      color: theme.palette.primary.main
    }, theme.breakpoints.up('md'), {
      marginTop: theme.spacing(0)
    }),
    linkDisabled: {
      color: theme.palette.grey[500]
    },
    checkboxIcon: {
      border: "1px solid ".concat(theme.palette.grey[500]),
      borderRadius: 3,
      height: '18px',
      width: '18px',
      fontSize: theme.typography.pxToRem(3.5)
    },
    checkboxIconChecked: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      '& svg': (0, _defineProperty2.default)({
        fontSize: theme.typography.pxToRem(16)
      }, theme.breakpoints.up('md'), {
        fontSize: theme.typography.pxToRem(12)
      })
    },
    collapsableFormGroup: (0, _defineProperty2.default)({}, theme.breakpoints.up('md'), {
      display: 'none'
    }),
    desktopFormGroup: (0, _defineProperty2.default)({
      display: 'none'
    }, theme.breakpoints.up('md'), {
      display: 'flex'
    })
  };
});
var formControlLabelStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: (0, _defineProperty2.default)({
      display: 'flex',
      margin: theme.spacing(2.5, 0, 3.5, 0)
    }, theme.breakpoints.up('md'), {
      margin: theme.spacing(0, 0, 4, 0)
    }),
    label: {
      lineHeight: '1.2 !important',
      display: 'flex',
      alignItems: 'center',
      fontSize: theme.typography.pxToRem(14)
    }
  };
});
var StyledCheckbox = (0, _styles.withStyles)(function (theme) {
  return {
    root: {
      padding: theme.spacing(0, 2, 0, 0)
    }
  };
})(_core.Checkbox);
var FilterControl = function FilterControl(props) {
  var _clsx2, _clsx3;
  var state = props.state,
    label = props.label,
    onChange = props.onChange,
    onChangeAll = props.onChangeAll,
    _props$uncheckallText = props.uncheckallText,
    uncheckallText = _props$uncheckallText === void 0 ? 'Uncheck All' : _props$uncheckallText;
  var _useState = (0, _react.useState)(true),
    isCollapsed = _useState[0],
    setIsCollapsed = _useState[1];
  var classes = useStyles();
  var formControlLabelStyle = formControlLabelStyles();
  var isSomeFacetChecked = Object.keys(state).some(function (item) {
    return state[item];
  });
  var handleOnChangeAll = function handleOnChangeAll(event) {
    event.preventDefault();
    onChangeAll === null || onChangeAll === void 0 ? void 0 : onChangeAll(!isSomeFacetChecked);
  };
  var toggleGroup = function toggleGroup() {
    setIsCollapsed(!isCollapsed);
  };
  return __jsx(_core.FormControl, {
    component: "fieldset",
    className: classes.wrapper
  }, __jsx("div", {
    className: classes.accordian,
    onClick: toggleGroup
  }, __jsx(_core.Typography, {
    component: "legend",
    className: classes.label,
    dangerouslySetInnerHTML: {
      __html: label
    }
  }), __jsx(_ExpandLess.default, {
    className: (0, _clsx4.default)(classes.expandIcon, (0, _defineProperty2.default)({}, classes.expandIconIsOpen, isCollapsed))
  })), __jsx(_core.Collapse, {
    className: classes.collapsableFormGroup,
    in: isCollapsed
  }, __jsx(_core.FormGroup, {
    className: classes.formGroup
  }, Object.keys(state).map(function (item, index) {
    return item && __jsx(_core.FormControlLabel, {
      key: index,
      classes: formControlLabelStyle,
      label: item,
      control: __jsx(StyledCheckbox, {
        size: "medium",
        color: "primary",
        checked: state[item],
        onChange: onChange,
        value: item,
        icon: __jsx("span", {
          className: classes.checkboxIcon
        }),
        checkedIcon: __jsx("span", {
          className: (0, _clsx4.default)(classes.checkboxIcon, classes.checkboxIconChecked)
        }, __jsx(_Check.default, null))
      })
    });
  }), onChangeAll && __jsx(_core.Typography, (0, _extends2.default)({
    component: isSomeFacetChecked ? 'a' : 'span'
  }, isSomeFacetChecked && {
    href: '#'
  }, {
    className: (0, _clsx4.default)((_clsx2 = {}, (0, _defineProperty2.default)(_clsx2, classes.link, true), (0, _defineProperty2.default)(_clsx2, classes.linkDisabled, !isSomeFacetChecked), _clsx2))
  }, isSomeFacetChecked && {
    onClick: handleOnChangeAll
  }), uncheckallText))), __jsx(_core.Typography, {
    component: "legend",
    className: (0, _clsx4.default)(classes.label, classes.labelDesktop),
    dangerouslySetInnerHTML: {
      __html: label
    }
  }), __jsx(_core.FormGroup, {
    className: classes.desktopFormGroup
  }, Object.keys(state).map(function (item, index) {
    return item && __jsx(_core.FormControlLabel, {
      key: index,
      classes: formControlLabelStyle,
      label: item,
      control: __jsx(StyledCheckbox, {
        size: "medium",
        color: "primary",
        checked: state[item],
        onChange: onChange,
        value: item,
        icon: __jsx("span", {
          className: classes.checkboxIcon
        }),
        checkedIcon: __jsx("span", {
          className: (0, _clsx4.default)(classes.checkboxIcon, classes.checkboxIconChecked)
        }, __jsx(_Check.default, null))
      })
    });
  }), onChangeAll && __jsx(_core.Typography, (0, _extends2.default)({
    component: isSomeFacetChecked ? 'a' : 'span'
  }, isSomeFacetChecked && {
    href: '#'
  }, {
    className: (0, _clsx4.default)((_clsx3 = {}, (0, _defineProperty2.default)(_clsx3, classes.link, true), (0, _defineProperty2.default)(_clsx3, classes.linkDisabled, !isSomeFacetChecked), _clsx3))
  }, isSomeFacetChecked && {
    onClick: handleOnChangeAll
  }, {
    dangerouslySetInnerHTML: {
      __html: uncheckallText
    }
  }))));
};
var _default = FilterControl;
exports.default = _default;